"use strict";
const { CAMPAIGN_COLLECTION_ID, TASK_COLLECTION_ID, TOUCHPOINT_COLLECTION_ID } = require('./consts');
const SYSTEM_COLLECTIONS = {
    [CAMPAIGN_COLLECTION_ID]: CAMPAIGN_COLLECTION_ID,
    [TASK_COLLECTION_ID]: TASK_COLLECTION_ID,
    [TOUCHPOINT_COLLECTION_ID]: TOUCHPOINT_COLLECTION_ID,
};
const GENERAL_COLLECTIONS = {
    [CAMPAIGN_COLLECTION_ID]: CAMPAIGN_COLLECTION_ID,
};
const isGeneralCollection = (collectionType) => Object.hasOwn(GENERAL_COLLECTIONS, collectionType);
const isSystemCollection = (collectionType) => Object.hasOwn(SYSTEM_COLLECTIONS, collectionType);
module.exports = {
    isGeneralCollection,
    isSystemCollection,
};
//# sourceMappingURL=utils.js.map